<template>
  <div
    class="d-flex align-center justify-space-between"
    :class="{ 'mt-2': isSignatureTypeSeal }"
  >
    <div
      class="signer-details-wrapper d-flex flex-column flex-fill"
      style="min-width: 0"
    >
      <!-- EMAIL -->
      <div
        class="signer-email text-truncate"
        :class="{ mobile: display.smAndDown.value }"
        data-test-id="signer-email"
      >
        {{ email }}
      </div>
      <!-- /EMAIL -->

      <slot name="signature-level"> </slot>
    </div>
    <!-- CHECK MARK -->
    <slot name="checkmark"> </slot>
    <!-- /CHECK MARK -->
  </div>
</template>

<script lang="ts" setup>
import { useSignStore } from '@/stores/sign.ts';
import { computed } from 'vue';
import { useDisplay } from 'vuetify/framework';

defineProps({
  email: {
    type: String,
    default: ''
  }
});

const signStore = useSignStore();
const display = useDisplay();

const isSignatureTypeSeal = computed(() => {
  return signStore.document?.signContext.signatureType === 'seal';
});
</script>

<style scoped lang="scss">
@use 'sass:map';
@use '@/styles/settings.scss' as *;

.signer-details-wrapper {
  max-width: 296px;

  @media #{map.get($display-breakpoints, 'md-and-up')} {
    max-width: 396px;
  }
}

.signer-email {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.0025em;
  color: black !important;

  &.mobile {
    font-size: 16px;
  }
}
</style>
